module.exports = ".login-box {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 300px;\n  height: 480px;\n  margin: -240px 0 0 -150px;\n  padding: 25px;\n  background: #fff;\n  border: 1px solid #ced5db;\n  border-radius: 4px;\n  -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);\n          box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15); }\n  .login-box .title {\n    position: relative;\n    width: 250px;\n    font-size: 25px;\n    text-align: center; }\n  .login-box .btn {\n    display: block;\n    margin-left: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/login/login.component.scss
// module id = ./src/app/modules/login/login.component.scss
// module chunks = main